import * as React from "react";
import "./FeedBack.scss";
import {
  AppBar,
  Box,
  Button,
  CssBaseline,
  Grid,
  Paper,
  SvgIcon,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import veryDifficultIcon from "./ImageListFeedback/VERY DIFFICULT.png";
import difficultIcon from "./ImageListFeedback/DIFFICULT.png";
import moderateIcon from "./ImageListFeedback/MODERATE.png";
import easyIcon from "./ImageListFeedback/EASY.png";
import veryEasyIcon from "./ImageListFeedback/EVERY EASY.png";
import ButtonField from "../../Components/Button/ButtonField";
import { addFeedBackPractice } from "../../Redux/Slices/FeedBackPractice/AddFeedBackPracticeSlice";
import { addFeedBack } from "../../Redux/Slices/FeedBack/AddFeedBackSlice";
import { ReactComponent as CheckLogo } from "../../Assets/Images/check-circle.svg";

export default function FeedBack() {
  const dispatch = useAppDispatch();
  const [details, setDetails] = React.useState<ILoginResponse>({});
  const [selectedOption, setSelectedOption] = React.useState<string | null>(
    null
  );
  const [dialogOpen, setDialogOpen] = React.useState(false);

  React.useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  const nameid: any = details?.id;
  const navigate = useNavigate();
  const { state: feedback_id } = useLocation();
  const { data: listexamlist } = useAppSelector(
    (state) => state.ListExamIDSlice
  );
  const List: any = listexamlist?.data?.exam_name;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const options = [
    {
      value: "Very Difficult",
      icon: veryDifficultIcon,
      color: "#f43f5e",
      line1: "Very",
      line2: "Difficult",
    },
    {
      value: "Difficult",
      icon: difficultIcon,
      color: "#f59e0b",
      line1: "Difficult",
    },
    {
      value: "Moderate",
      icon: moderateIcon,
      color: "#6b7280",
      line1: "Moderate",
    },
    {
      value: "Easy",
      icon: easyIcon,
      color: "#22c55e",
      line1: "Easy",
    },
    {
      value: "Very Easy",
      icon: veryEasyIcon,
      color: "#3b82f6",
      line1: "Very",
      line2: "Easy",
    },
  ];

  const handleSubmitFeedback = () => {
    if (selectedOption) {
      // Prepare feedback data according to your payload format
      const feedbackData = {
        user_id: nameid,
        feedback: selectedOption,
        student_exam_id: feedback_id, // Using feedback_id from useLocation state
        comments: "string", // Default comment or you can add a state for this
      };

      // Dispatch the action - choose the appropriate one based on your needs
      dispatch(addFeedBack(feedbackData));
      // OR
      // dispatch(addFeedBackPractice(feedbackData));

      // Show success dialog
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogOk = () => {
    setDialogOpen(false);
    sessionStorage.removeItem("timestorage");
    navigate("/dashboard");
  };

  return (
    <div style={{ backgroundColor: "#f5f9ff", height: "100vh" }}>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin: "0% 8%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back To Home
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
        </Box>
      </Box>

      <Paper
        elevation={0}
        sx={{
          mt: 4,
          p: isMobile ? 2 : 4,
          borderRadius: 3,
          backgroundColor: "#ffffff",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
          maxWidth: 800,
          mx: "auto",
          marginTop: "10rem",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#0f172a",
            mb: 2,
            textAlign: "center",
          }}
        >
          Feedback
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            color: "#64748b",
            mb: 4,
            textAlign: "center",
          }}
        >
          How did you find this Exam?
        </Typography>

        <Grid
          container
          spacing={isMobile ? 1 : 3}
          justifyContent="center"
          sx={{ mb: 4 }}
        >
          {options?.map((option) => (
            <Grid item key={option.value} xs={6} sm="auto">
              <Button
                variant="outlined"
                onClick={() => setSelectedOption(option.value)}
                sx={{
                  minWidth: isMobile ? "100%" : 100,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  borderWidth: selectedOption === option.value ? 2 : 1,
                  borderColor:
                    selectedOption === option.value ? "#1e90ff" : "#e0e0e0",
                  backgroundColor:
                    selectedOption === option.value ? "#e0f2ff" : "#ffffff",
                  color: "#1e293b",
                  transition: "all 0.2s ease",
                  boxShadow:
                    selectedOption === option.value
                      ? "0 0 0 2px rgba(30, 144, 255, 0.4)"
                      : "none",
                  "&:hover": {
                    backgroundColor:
                      selectedOption === option.value ? "#e0f2ff" : "#f9fafb",
                    borderColor: "#1e90ff",
                  },
                  py: 2,
                  px: isMobile ? 1 : 2,
                  textTransform: "none",
                }}
              >
                <Box
                  sx={{
                    mb: 1,
                    filter:
                      selectedOption === option.value
                        ? "brightness(1.1)"
                        : "grayscale(0)",
                    transition: "filter 0.2s ease",
                  }}
                >
                  <img
                    src={option.icon}
                    alt={option.value}
                    style={{
                      width: 36,
                      height: 36,
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      fontSize: isMobile ? "0.9rem" : "1rem",
                      lineHeight: 1.2,
                      color:
                        selectedOption === option.value ? "#1e90ff" : "#1e293b",
                    }}
                  >
                    {option.line1}
                  </Typography>
                  {option.line2 && (
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 700,
                        fontSize: isMobile ? "0.9rem" : "1rem",
                        lineHeight: 1.2,
                        color:
                          selectedOption === option.value
                            ? "#1e90ff"
                            : "#1e293b",
                      }}
                    >
                      {option.line2}
                    </Typography>
                  )}
                </Box>
              </Button>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 4,
          }}
        >
          <ButtonField
            variant="outlined"
            color="primary"
            className="buttonprevious"
            sx={{ width: "100%" }}
            onClick={() => {
              sessionStorage.removeItem("timestorage");
              navigate("/dashboard");
            }}
          >
            Skip
          </ButtonField>

          <ButtonField
            variant="contained"
            color="primary"
            disabled={!selectedOption}
            className="buttonnext"
            onClick={handleSubmitFeedback}
          >
            Submit Feedback
          </ButtonField>
        </Box>
      </Paper>

      {/* Success Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="feedback-dialog-title"
        aria-describedby="feedback-dialog-description"
      >
        <DialogTitle
          id="feedback-dialog-title"
          sx={{
            fontSize: "16px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 2 }}
          >
            <CheckLogo
              style={{ width: "80px", height: "80px", color: "#4caf50" }}
            />
          </Box>
          <Typography sx={{ fontSize: "16px" }}>
            Feedback Submitted Successfully
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="feedback-dialog-description"
            sx={{ fontSize: "14px", fontWeight: "500" }}
          >
            Thank you for your feedback! Your response has been recorded.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleDialogOk}
            color="primary"
            variant="contained"
            sx={{
              fontSize: "14px",
              backgroundColor: "#009dff",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#009dff",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
